import script from "./ReminderFollowupModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReminderFollowupModal.vue?vue&type=script&setup=true&lang=ts"

import "./ReminderFollowupModal.vue?vue&type=style&index=0&id=5ee4852c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ee4852c"]])

export default __exports__